<svelte:head>
</svelte:head>

<script>

import { onMount, onDestroy } from 'svelte';

var display_jwt = false;

var data = [];

	onMount(async () => {

		setTimeout(async function(){ 
	
        		
		
			 }, 
			 10);
		  
	});

</script>


<style>

	.page {
	}

</style>


<div class="page">

	<div>
		<div>JWT :: WorkBench</div>
		<div>App Test JWT</div>
	</div>

	{#if display_jwt}
	<div></div>
	
	{:else}
	<div>
			Loading data and scripts and what not...
	</div>

	{/if}
	
</div>

